import React from 'react';
import SiteContentContext from '../../content/SiteContentContext';
import { getByPath, getTranslations, resolveMediaSrc } from '../../content/siteContentUtils';

const fallbackSliderImages = [
  require('./../../images/main-slider/slider1/slide3.jpg'),
  require('./../../images/main-slider/slider1/slide1.jpg'),
  require('./../../images/main-slider/slider1/slide2.jpg'),
];

const fallbackSliderTexts = [
  {
    tagLine: 'Güvenlik',
    title: 'Evinizin Güvenli ve Sik Kapisi',
    description: 'Firat Çelik Kapi ile evinizde huzuru ve estetigi bir arada yasayin.',
    buttonLabel: 'Daha Fazla Oku',
  },
  {
    tagLine: 'Modern Tasarim',
    title: 'Saglamlik ve Estetik Bir Arada',
    description: 'Yüksek güvenlikli kilit sistemleri ve modern tasarimlarimizla hizmetinizdeyiz.',
    buttonLabel: 'Read More',
  },
  {
    tagLine: 'Kalite',
    title: 'Yillarin Verdigi Tecrübe',
    description: 'Müsteri memnuniyeti odakli hizmet anlayisimizla en iyi çelik kapilari üretiyoruz.',
    buttonLabel: 'Read More',
  },
];

const isUsableImageUrl = (value) => {
  const url = typeof value === 'string' ? value.trim() : '';
  if (!url) return false;

  const lower = url.toLowerCase();
  if (lower.startsWith('blob:') || lower.startsWith('file:')) return false;
  if (lower.includes('fakepath')) return false;
  if (/^[a-z]:\\/.test(lower)) return false;

  return true;
};

class Slider1 extends React.Component {
  static contextType = SiteContentContext;

  constructor(props) {
    super(props);
    this.mobileMediaQuery = null;
    this.mobileMediaQueryListener = null;
    this.state = {
      isMobileViewport: false,
    };
  }

  componentDidMount() {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      this.mobileMediaQuery = window.matchMedia('(max-width: 767px)');
      this.mobileMediaQueryListener = (event) => {
        this.setState({ isMobileViewport: Boolean(event.matches) });
      };

      this.setState({ isMobileViewport: Boolean(this.mobileMediaQuery.matches) });

      if (typeof this.mobileMediaQuery.addEventListener === 'function') {
        this.mobileMediaQuery.addEventListener('change', this.mobileMediaQueryListener);
      } else if (typeof this.mobileMediaQuery.addListener === 'function') {
        this.mobileMediaQuery.addListener(this.mobileMediaQueryListener);
      }
    }

    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = src;
        script.addEventListener('load', function () {
          resolve();
        });
        script.addEventListener('error', function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript('./assets/js/rev-script-1.js');
  }

  componentWillUnmount() {
    if (!this.mobileMediaQuery || !this.mobileMediaQueryListener) {
      return;
    }

    if (typeof this.mobileMediaQuery.removeEventListener === 'function') {
      this.mobileMediaQuery.removeEventListener('change', this.mobileMediaQueryListener);
    } else if (typeof this.mobileMediaQuery.removeListener === 'function') {
      this.mobileMediaQuery.removeListener(this.mobileMediaQueryListener);
    }
  }

  getSlides(content, t) {
    const mediaSlides = getByPath(content, 'home.slider.slides', []);
    const textSlides = t?.pages?.home?.slider?.slides || [];
    const length = Math.max(mediaSlides.length || 0, textSlides.length || 0, fallbackSliderTexts.length);

    return Array.from({ length }).map((_, index) => {
      const media = mediaSlides[index] || {};
      const text = textSlides[index] || {};
      const fallbackText = fallbackSliderTexts[index] || fallbackSliderTexts[fallbackSliderTexts.length - 1];
      const fallbackImage = fallbackSliderImages[index] || fallbackSliderImages[fallbackSliderImages.length - 1];
      const desktopCandidate = resolveMediaSrc(media.imageUrl, '');
      const imageSrc = isUsableImageUrl(desktopCandidate) ? desktopCandidate : fallbackImage;
      const mobileCandidate = resolveMediaSrc(media.mobileImageUrl, '');
      const mobileImageSrc = isUsableImageUrl(mobileCandidate) ? mobileCandidate : imageSrc;

      return {
        keyId: 72 + index,
        imageSrc,
        mobileImageSrc,
        buttonUrl: media.buttonUrl || '#',
        tagLine: text.tagLine || fallbackText.tagLine,
        title: text.title || fallbackText.title,
        description: text.description || fallbackText.description,
        buttonLabel: text.buttonLabel || fallbackText.buttonLabel,
      };
    });
  }

  renderSlide(slide, index) {
    const slideId = slide.keyId;
    const selectedImageSrc =
      this.state.isMobileViewport && isUsableImageUrl(slide.mobileImageSrc)
        ? slide.mobileImageSrc
        : slide.imageSrc;
    const fallbackImageSrc = slide.imageSrc;

    return (
      <li
        key={`hero-slide-${slideId}`}
        data-index={`rs-${slideId}`}
        data-transition="fade"
        data-slotamount="default"
        data-randomtransition="off"
        data-hideafterloop={0}
        data-hideslideonmobile="off"
        data-easein="default"
        data-easeout="default"
        data-masterspeed={300}
        data-thumb={selectedImageSrc}
        data-rotate={0}
        data-saveperformance="off"
        data-title=""
        data-param1={1}
        data-param2=""
        data-param3=""
        data-param4=""
        data-param5=""
        data-param6=""
        data-param7=""
        data-param8=""
        data-param9=""
        data-param10=""
        data-description=""
      >
        <img
          src={selectedImageSrc}
          alt=""
          onError={(event) => {
            if (event.currentTarget.dataset.fallbackApplied === 'true') return;
            event.currentTarget.dataset.fallbackApplied = 'true';
            event.currentTarget.src = fallbackImageSrc;
          }}
          data-bgcolor="#f8f8f8"
          style={{}}
          data-bgposition="center center"
          data-bgfit="cover"
          data-bgrepeat="no-repeat"
          data-bgparallax="off"
          data-kenburns="off"
          className="rev-slidebg"
          data-no-retina
        />

        <div className="mobile-slider-copy">
          <div className="mobile-slider-tag">{slide.tagLine}</div>
          <div className="mobile-slider-title">{slide.title}</div>
          <div className="mobile-slider-desc">{slide.description}</div>
        </div>

        <div
          className="tp-caption tp-resizeme slider-tag-line"
          id={`slide-${slideId}-layer-3`}
          data-x="['left','left','left','left']"
          data-hoffset="['40','24','22','18']"
          data-y="['top','top','top','top']"
          data-voffset="['150','140','70','50']"
          data-fontsize="['30','24','22','18']"
          data-lineheight="['38','32','30','24']"
          data-width="['900','760','560','320']"
          data-height="none"
          data-whitespace="nowrap"
          data-type="text"
          data-responsive_offset="on"
          data-frames="[{&quot;delay&quot;:300,&quot;speed&quot;:750,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;y:25px;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power3.easeOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:500,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]"
          data-textalign="['left','left','left','left']"
          data-paddingtop="[0,0,0,0]"
          data-paddingright="[0,0,0,0]"
          data-paddingbottom="[0,0,0,0]"
          data-paddingleft="[0,0,0,0]"
          style={{ zIndex: 10, fontWeight: 500, letterSpacing: 6, color: '#fff', fontFamily: '"Poppins", sans-serif', textTransform: 'uppercase' }}
        >
          {slide.tagLine}
        </div>

        <div
          className="tp-caption tp-resizeme slider-main-title"
          id={`slide-${slideId}-layer-4`}
          data-x="['left','left','left','left']"
          data-hoffset="['36','20','20','16']"
          data-y="['top','top','top','top']"
          data-voffset="['206','192','108','82']"
          data-fontsize="['55','55','40','32']"
          data-lineheight="['72','60','48','38']"
          data-width="['1020','820','620','360']"
          data-height="none"
          data-whitespace="normal"
          data-type="text"
          data-responsive_offset="on"
          data-frames="[{&quot;delay&quot;:200,&quot;speed&quot;:750,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;y:30px;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power3.easeOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:500,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]"
          data-textalign="['left','left','left','left']"
          data-paddingtop="[0,0,0,0]"
          data-paddingright="[0,0,0,0]"
          data-paddingbottom="[0,0,0,0]"
          data-paddingleft="[0,0,0,0]"
          style={{ zIndex: 10, whiteSpace: 'normal', fontWeight: 800, color: '#fff', fontFamily: '"Poppins", sans-serif' }}
        >
          {slide.title}
        </div>

        <div
          className="tp-caption tp-resizeme slider-desc"
          id={`slide-${slideId}-layer-5`}
          data-x="['left','left','left','left']"
          data-hoffset="['40','24','22','18']"
          data-y="['top','top','top','top']"
          data-voffset="['314','296','188','150']"
          data-fontsize="['18','17','16','15']"
          data-lineheight="['30','28','26','24']"
          data-width="['760','640','500','320']"
          data-height="none"
          data-whitespace="normal"
          data-type="text"
          data-responsive_offset="on"
          data-frames="[{&quot;delay&quot;:200,&quot;speed&quot;:750,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;y:25px;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power3.easeOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:500,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]"
          data-textalign="['left','left','left','left']"
          data-paddingtop="[0,0,0,0]"
          data-paddingright="[0,0,0,0]"
          data-paddingbottom="[0,0,0,0]"
          data-paddingleft="[0,0,0,0]"
          style={{ zIndex: 10, whiteSpace: 'normal', color: '#fff', fontFamily: '"Poppins", sans-serif', fontWeight: 500 }}
        >
          {slide.description}
        </div>

        <div
          className="tp-caption tp-shape tp-shapewrapper"
          id={`slide-${slideId}-layer-8`}
          data-x="['center','center','center','center']"
          data-hoffset="['0','0','0','0']"
          data-y="['middle','middle','middle','middle']"
          data-voffset="['0','0','0','0']"
          data-width="full"
          data-height="full"
          data-whitespace="nowrap"
          data-visibility="['on','off','off','off']"
          data-type="shape"
          data-basealign="slide"
          data-responsive_offset="off"
          data-responsive="off"
          data-frames="[{&quot;delay&quot;:50,&quot;speed&quot;:100,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:1000,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeIn&quot;}]"
          data-textalign="['inherit','inherit','inherit','inherit']"
          data-paddingtop="[0,0,0,0]"
          data-paddingright="[0,0,0,0]"
          data-paddingbottom="[0,0,0,0]"
          data-paddingleft="[0,0,0,0]"
          style={{ zIndex: 8, backgroundColor: 'rgba(0, 0, 0, 0)', borderLeft: '40px solid #eef1f2' }}
        > </div>

        <div
          className="tp-caption tp-shape tp-shapewrapper"
          id={`slide-${slideId}-layer-7`}
          data-x="['center','center','center','center']"
          data-hoffset="['0','0','0','0']"
          data-y="['middle','middle','middle','middle']"
          data-voffset="['0','0','0','0']"
          data-width="full"
          data-height="full"
          data-whitespace="nowrap"
          data-visibility="['on','on','off','off']"
          data-type="shape"
          data-basealign="slide"
          data-responsive_offset="off"
          data-responsive="off"
          data-frames="[{&quot;delay&quot;:50,&quot;speed&quot;:100,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:1000,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeIn&quot;}]"
          data-textalign="['inherit','inherit','inherit','inherit']"
          data-paddingtop="[0,0,0,0]"
          data-paddingright="[0,0,0,0]"
          data-paddingbottom="[0,0,0,0]"
          data-paddingleft="[0,0,0,0]"
          style={{ zIndex: 8, backgroundColor: 'rgba(0, 0, 0, 0)', borderBottom: '24px solid #eef1f2' }}
        > </div>
      </li>
    );
  }

  render() {
    const content = this.context?.content || {};
    const t = getTranslations(content);
    const slides = this.getSlides(content, t);

    return (
      <>
        <div id="rev_slider_26_1_wrapper" className="rev_slider_wrapper fullscreen-container home-rev-slider" data-alias="mask-showcase" data-source="gallery">
          <div id="rev_slider_26_1" className="rev_slider fullscreenbanner" style={{ display: 'none' }} data-version="5.4.1">
            <ul>
              {slides.map((slide, index) => this.renderSlide(slide, index))}
            </ul>
            <div className="tp-bannertimer" />

          </div>
        </div>
      </>
    );
  }
}

export default Slider1;

